import Shopify from "./views/shopify/shopify";
const routes = [
    {
        path: '/',
        name: 'Home',
        component: Shopify,
    }
]

export default routes